module.exports = __webpack_public_path__ + "img/step_04.2092dead.jpg";